import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIdCard,
  faUserPlus,
  faUsers,
  faSitemap,
  faShoppingCart,
  faIndianRupee,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Button } from "@themesberg/react-bootstrap";

import DashboardStatCard from "../dashboard/DashboardStatCard";
import { ACTIVE_BUTTON_STYLE, buildReferralLink } from "../dashboard/dashboardHelpers";
import { formatCurrency } from "./networkHelpers";

export default function NetworkSummary({
  loading = false,
  userId = "—",
  referralCode = "",
  directCount = 0,
  totalDownline = 0,
  purchasedCount = 0,
  totalCommission = 0,
}) {
  const referralLink = buildReferralLink(referralCode);

  const handleCopy = (label) => toast.success(`${label} copied to clipboard`);

  return (
    <>
      <Row className="g-3 mb-3">
        <Col xs={12} sm={6} xl={4}>
          <DashboardStatCard
            title="My User ID"
            subtitle="Your account identifier"
            value={userId}
            icon={faIdCard}
            tone="dark"
            loading={loading}
          />
        </Col>
        <Col xs={12} sm={6} xl={4}>
          <DashboardStatCard
            title="Referral Code"
            subtitle="Share to invite users"
            value={referralCode || "—"}
            icon={faUserPlus}
            tone="primary"
            loading={loading}
          />
        </Col>
        <Col xs={12} sm={6} xl={4}>
          <DashboardStatCard
            title="Direct Referrals"
            subtitle="Users you personally referred"
            value={directCount}
            icon={faUsers}
            tone="info"
            loading={loading}
          />
        </Col>
        <Col xs={12} sm={6} xl={4}>
          <DashboardStatCard
            title="Total Downline"
            subtitle="All team members"
            value={totalDownline}
            icon={faSitemap}
            tone="primary"
            loading={loading}
          />
        </Col>
        <Col xs={12} sm={6} xl={4}>
          <DashboardStatCard
            title="Purchased Users"
            subtitle="Direct referrals with purchase*"
            value={purchasedCount}
            icon={faShoppingCart}
            tone="success"
            loading={loading}
            footer="*Based on available purchase data"
          />
        </Col>
        <Col xs={12} sm={6} xl={4}>
          <DashboardStatCard
            title="Total Commission"
            subtitle="Earned from your network"
            value={formatCurrency(totalCommission)}
            icon={faIndianRupee}
            tone="success"
            loading={loading}
          />
        </Col>
      </Row>

      {referralCode && (
        <div className="d-flex flex-wrap gap-2 mb-4">
          <CopyToClipboard text={referralCode} onCopy={() => handleCopy("Referral code")}>
            <Button variant="outline-primary" size="sm" className="dashboard-quick-action-btn">
              <FontAwesomeIcon icon={faCopy} className="me-1" />
              Copy Referral Code
            </Button>
          </CopyToClipboard>
          {referralLink && (
            <CopyToClipboard text={referralLink} onCopy={() => handleCopy("Referral link")}>
              <Button style={ACTIVE_BUTTON_STYLE} size="sm" className="dashboard-quick-action-btn">
                <FontAwesomeIcon icon={faCopy} className="me-1" />
                Copy Referral Link
              </Button>
            </CopyToClipboard>
          )}
        </div>
      )}
    </>
  );
}
